<template>
  <div class="count">
    <!--头部导航-->
    <top-nav ref="TopNav"></top-nav>
    <van-nav-bar title="限时抢购" fixed left-arrow @click-left="goBack" @click-right="onClickRight">
      <van-icon slot="right" class="iconfont icon-zhankai"></van-icon>
    </van-nav-bar>
    <div class="van-content">
      <van-cell-group>
        <img src="/static/images/countbanner.png" />
      </van-cell-group>
      <van-cell-group>
        <van-list v-model="loading" :finished="finished" @load="getDatas" :offset="-1">
          <van-cell-group>
            <van-card class="goodsonelist" v-for="items in datas" :key="items.id">
              <router-link slot="thumb" class="goodsimgbox" :to="{path:'/goodslist/goods',query:{id:items.id}}">
                <img :src="items.product_img" onerror="src='/static/errorimg1.png'">
              </router-link>
              <div slot="title" class="ellipseal van-card-title">
                <div class="ellipse">
                  <span plain class="theme-col theme-bg radius jd" v-if="items.dummy == 3">京东</span>{{ items.product_name }}
                </div>
                <div style="margin: 5px 0" v-if="items.time > 1000" class="countbox">
                  <span class="theme-col bg-fff">剩</span>
                  <span>{{ parseInt((items.end_time-items.time)/(24*60*60)) }}</span> 天 <span>{{ parseInt((items.end_time-items.time)/(60*60)%24) }}</span>：<span>{{ parseInt((items.end_time-items.time)/(60)%60) }}</span>：<span>{{ parseInt((items.end_time-items.time)/(1)%60) }}</span>
                </div>
                <div style="margin: 5px 0" v-else="items.time > 1000">时间到</div>
              </div>
              <div slot="desc" class="van-card-desc theme-col">
                <p style="margin-bottom: 5px">
                  <span class="theme-col ft3">{{ items.points_price }}</span>
                  <!--<span class="oldprice" v-if="items.old_points_price != 0 && items.old_money_price != 0">{{ items.old_points_price }}{{  configData.integral_name}}+{{ items.old_money_price }}元</span>-->
                  <!--<span class="oldprice" v-if="items.old_points_price != 0 && items.old_money_price == 0">{{ items.old_points_price }}{{  configData.integral_name}}</span>-->
                  <!--<span class="oldprice" v-if="items.old_points_price == 0 && items.old_money_price != 0">{{ items.old_money_price }}元</span>-->
                </p>
                <p><router-link :to="{path:'/goodslist/goods',query:{id:items.id}}" class="theme-bg theme-bd van-button van-button--default van-button--small">立即抢购</router-link></p>
              </div>
              <!--<div slot="footer">
                <van-icon class="iconfont icon-gouwuche1 theme-col ft3" @click.stop="addCart(items.id)"></van-icon>
              </div>-->
            </van-card>
            <div v-if="!loading && finished" class="nomore"><span>已经到底了</span></div>
          </van-cell-group>
        </van-list>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
  import TopNav from '@/components/topnav'
  export default {
    name: "count",
    props:['configData'],
    data () {
      return {
        datas:[],
        page:0,
        loading:false,//下拉加载状态
        finished:false,//下拉加载是否开启
      }
    },
    components: {
      TopNav
    },
    methods: {
      goBack: function () {
        history.back(-1);
      },
      onClickRight() {
        this.$refs.TopNav.topnavPlay()
      },
      getDatas: function () {
        var _this = this
        setTimeout(() => {
          this.page++
          this.$api.get('WebApi/product/Product/index', {is_rob:1,p:this.page}, res => {
            if (res.data.data.length == 0) {
              _this.finished = true;
              _this.loading = false;
            } else {
              for (let i = 0; i < res.data.data.length; i++) {
                _this.datas.push(res.data.data[i]);
              }
              _this.loading = false;
              _this.countDown()
            }
          })
        }, 50)
      },
      countDown: function () {
        var _this = this;
        for(let i=0;i<_this.datas.length;i++){
          if(_this.datas[i].time != undefined){
            setInterval(function () {
              if(_this.datas[i].time < _this.datas[i].end_time){
                var counttime = _this.datas[i].time + 1
                _this.datas[i].time = counttime
              }else{

              }
            },1000)
          }else{

          }
        }
      }
    },
    mounted () {
    },
  }
</script>

<style lang="less">
.count{
  .goodsonelist{
    .van-card-title{
      height: auto;
    }
  }
  .van-card{
    margin: 0;
    border-bottom: 1px solid #f2f2f2;
    padding-left: 120px ;
    .countbox{
      span{
        display: inline-block;
        text-align: center;
        padding: 2px 4px 2px 3px;
        box-sizing: border-box;
        background: #4c4c56;
        border-radius: 2px;
        color: #fff;
        min-width: 23px;
      }
    }
    .van-card__thumb{
      height: 100px;
      width: 100px;
      left: 10px;
    }
    .oldprice{
      text-decoration: line-through;
      color: #999;
    }
    .radius {
      padding: 0 5px 1px!important;
      -webkit-border-radius:10px 0;
      -moz-border-radius:10px 0;
      border-radius:10px 0 ;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/count.vue